import { Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { debounceTime } from 'rxjs/operators';
import { MainsComponent } from 'src/common/pages/mains/mains.component';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SelectService } from 'src/common/services/select/select.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { Action } from 'src/services/action/action.model';
import { ActionPageService } from 'src/services/action/action.service';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.scss']
})
export class AccountingComponent extends MainsComponent {

  // public newRequests: ActionService = null;
  public actionItem = new Action(null, this.settings);
  public GLOBAL = new GlobalConstants();

  public preview: any = null;

  constructor(
    protected afs: AngularFirestore,
    public db: ActionPageService,
    public settings: SettingService,
    public backURL: BackurlService,
    protected router: Router,
    public setting: SettingService,
    public select: SelectService,
    protected fb: FormBuilder,
  ) {
    super(setting, db, select, router, fb, backURL);

    this.sortServerForm = this.fb.group({
      agency: [],
      realtor: [],
      filters: this.fb.group({
        type: ['payment'],
        done: [false],
      }),
      sort: null,
    });

    this.sortLocalForm = this.fb.group({
      sort: this.fb.group({
        active: ['due'],
        direction: ['asc'],
      }),
    });

  }



  protected initFilters(filters?: any) {

    // Subscribe to Local Filter Change
    this.searchForm.valueChanges.pipe(debounceTime(500)).subscribe(filters => {
      this.db.filterLoading = true;
      setTimeout(() => {
        this.db.setSearchFilter(filters.search);
      }, 10);
    });



    // LOCAL FILTER
    // if (this.sortLocalForm) {
    //   if (this.select.active && this.select.filters && this.select.filters.local) {
    //     this.sortLocalForm.patchValue(this.select.filters.local);
    //     this.db.setLocalFilter(this.select.filters.local);
    //     if (this.select.filters.local.localSearch) {
    //       this.db.setSearchFilter(this.select.filters.local.localSearch);
    //     }
    //   }
    //   else if (this.db.localFilters) {
    //     this.sortLocalForm.patchValue(this.db.localFilters);
    //     this.db.setLocalFilter(this.db.localFilters);
    //   }

    //   // Subscribe to Local Filter Change
    //   this.sortLocalForm.valueChanges.pipe(debounceTime(500)).subscribe(filters => {
    //     this.db.filterLoading = true;
    //     setTimeout(() => {
    //       this.db.setLocalFilter(filters);
    //     }, 10);
    //   });
    // }


    this.db.setLocalFilter(this.sortLocalForm.value);

    // SERVER FILTER

    this.db.setServerFilter(this.sortServerForm.value);
    // Subscribe to Server Filter Change
    this.sortServerForm.valueChanges.pipe(debounceTime(500)).subscribe(filters => {
      this.db.serverLoading = true;
      setTimeout(() => {
        this.db.setServerFilter(filters);
      }, 10);
    });


  }



  goItem(item: any) {
    this.backURL.addURL('/accounting');
    if (item.project && item.project.$key) {
      this.router.navigate([`/projects/${item.project.$key}`]);
    } else if (item.mandate && item.mandate.$key) {
      this.router.navigate([`/mandates/${item.mandate.$key}`]);
    }
  }
}
